export enum SocketEvent {
    SUPPORT_MESSAGE_INCOME = 'support_message_income',
    SUPPORT_MESSAGE_OUTGOING = 'support_message_outgoing',
}